module.exports = __webpack_public_path__ + "img/DSCN1401 copy.84b13020.jpg";